import React, { useState } from 'react';

/* MUI */
import { makeStyles } from '@material-ui/core/styles';
import { Container, Paper, IconButton } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import EditIcon from '@material-ui/icons/RateReviewOutlined';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginTop: "20px",
    marginBottom: "20px"
  }
}));

const ManageArea = props => {
  const classes = useStyles();
  const [page, setPage] = useState(5);

  const header = [
    { field: 'mapblklot', headerName: 'Map Block Lot', width: 250 },
    { field: 'assessorblklot', headerName: 'Assessor Block Lot', width: 250 },
    { field: 'excludedArea', headerName: 'Excluded Area', width: 250 },
    { field: 'revisedExcludedArea', headerName: 'Revised Excluded Area', width: 250 },
    { 
      field: 'review', 
      headerName: 'Review', 
      width: 150,
      sortable: false,
      renderCell: (params) => {
          const reviewButton = () => {
              //placeholder
          }; 
          return <IconButton color='primary' aria-label='review' onClick={reviewButton}>
                  <EditIcon />
                </IconButton>
      }
    }
  ];

  const jobs = [
    { 'mapblklot': '3507041', 'assessorblklot': '0000/000', 'excludedArea': '555', 'revisedExcludedArea': '652' },
    { 'mapblklot': '5383024', 'assessorblklot': '0009/000', 'excludedArea': '453', 'revisedExcludedArea': '512' },
  ];

  return (
    <Container maxWidth="lg">
      <Paper className={classes.paper}>
        <DataGrid
          columns={header}
          rows={jobs}
          getRowId={(row) => row.mapblklot}
          pageSize={page}
          onPageSizeChange={(pageSize) => { setPage(pageSize); }}
          autoHeight
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>
    </Container>
  )
};

export default ManageArea;